module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 367
// module chunks = 1 5 6 7 9 10 11 13 15 16 22 23 25 29 30 59